import React from 'react';
import { Dropdown } from 'antd';
import { ChevronDown, LayoutGrid } from 'lucide-react';
import { H } from './design-tokens';
import { dimensions } from '../theme';
import { ActionButton } from '../buttons';
import type { PlatformModule } from './platform-header';

const { radius, size } = dimensions;

export const ModuleDropdown: React.FC<{
  modules: PlatformModule[];
  activeModule: string;
  activeLabel: string;
  onModuleChange: (id: string) => void;
}> = ({ modules, activeModule, activeLabel, onModuleChange }) => {
  const dropdownContent = (
    <div
      style={{
        display: 'flex',
        gap: 8,
        padding: '8px',
        background: H.dropdownBg,
        borderRadius: radius.xl,
        boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.25)'
      }}
    >
      {modules.map(m => {
        const isActive = m.id === activeModule;
        return (
          <ActionButton key={m.id} variant={isActive ? 'secondary' : 'outline'} onClick={() => onModuleChange(m.id)}>
            {m.icon}
            {m.label}
          </ActionButton>
        );
      })}
    </div>
  );

  return (
    <Dropdown popupRender={() => dropdownContent} trigger={['click']}>
      <ActionButton variant='primary'>
        <LayoutGrid size={size.iconSm} />
        {activeLabel}
        <ChevronDown size={size.iconSm} />
      </ActionButton>
    </Dropdown>
  );
};
